import { Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';
import { useStorageType } from '@diamond/sol-admin/features/product';

import { useActivityDetail } from '../../../hooks/use-activity-detail';
import { EditableColumnProps } from '../../../types/activity-column-types';

interface Props
  extends EditableColumnProps<
    BackofficeActivitiesOrderItem,
    string | null | undefined
  > {
  activitiesId: string;
  token?: string;
  refetch: () => void;
}

export function StorageTypeColumn({
  info,
  selectedData,
  onUpdate,
  activitiesId,
  token,
  refetch,
}: Props) {
  const { data } = useStorageType();
  const { handlePatchData } = useActivityDetail({
    selectedData,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSelectedData: () => {},
    refetch,
    activitiesId,
    token,
  });

  const isSelected = selectedData.some(
    (row) => row.original.id === info.row.original.id
  );

  const emptyItem = {
    label: '',
    value: '',
  };

  const storageTypeItems = data
    ? [
        emptyItem,
        ...data.map((value) => ({
          label: value,
          value: value,
        })),
      ]
    : [emptyItem];

  const handleEdit = (value: string) => {
    onUpdate(value, info.row.original.id);
    handlePatchData({ product_storage: value }, '', info.row.original.id);
  };

  if (isSelected) {
    return (
      <div
        className="px-1"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {storageTypeItems.length > 1 && (
          <select
            name="product_storage"
            id="product_storage"
            style={{ padding: '4px' }}
            onChange={(e) => handleEdit(e.target.value)}
            defaultValue={info.row.original.product_storage ?? []}
          >
            {storageTypeItems.map((value, index) => {
              return (
                <option value={value.value} key={index}>
                  {value.label}
                </option>
              );
            })}
          </select>
        )}
      </div>
    );
  }

  return (
    <Text
      fontSize="sm"
      fontWeight="400"
      color="#373F41"
      w="full"
      textAlign="center"
    >
      {info.getValue() ?? '-'}
    </Text>
  );
}
